import { useState, useCallback } from 'react';
import { UserInteractions } from '../types';

export function useUserInteractions() {
  const [userInteractions, setUserInteractions] = useState<UserInteractions>({
    hasModifiedActivity: false,
    hasModifiedVacation: false,
    hasModifiedCharges: false,
    hasViewedCharges: false,
    hasModifiedPrimes: false
  });

  const markActivityModified = useCallback(() => {
    setUserInteractions(prev => ({ ...prev, hasModifiedActivity: true }));
  }, []);

  const markVacationModified = useCallback(() => {
    setUserInteractions(prev => ({ ...prev, hasModifiedVacation: true }));
  }, []);

  const markChargesModified = useCallback(() => {
    setUserInteractions(prev => ({ ...prev, hasModifiedCharges: true, hasViewedCharges: true }));
  }, []);

  const markPrimesModified = useCallback(() => {
    setUserInteractions(prev => ({ ...prev, hasModifiedPrimes: true }));
  }, []);

  return {
    userInteractions,
    markActivityModified,
    markVacationModified,
    markChargesModified,
    markPrimesModified
  };
}